(function () {
  'use strict';
  if (window.DaLucaStrapAddonsV360) return;
  window.DaLucaStrapAddonsV360 = true;

  function root() { return document.querySelector('.daluca-pdp--watch-strap'); }
  function shopRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    return String(r || '/').replace(/\/?$/, '/');
  }
  function url(path) { return shopRoot() + String(path || '').replace(/^\//,''); }
  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:currency || 'USD'}).format((Number(cents)||0)/100); }
    catch (_) { return '$' + ((Number(cents)||0)/100).toFixed(2); }
  }
  async function readJson(response, fallback) {
    var data = null;
    try { data = await response.json(); } catch (_) {}
    if (!response.ok || (data && data.status && Number(data.status) >= 400)) {
      throw new Error((data && (data.description || data.message)) || fallback || 'Unable to update cart.');
    }
    return data;
  }
  async function getCart() {
    return readJson(await fetch(url('cart.js'),{headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin',cache:'no-store'}),'Unable to read cart.');
  }
  function addonOwner() { return document.querySelector('[data-daluca-visualizer]')?.dataset.productHandle || root()?.dataset.handle || location.pathname.split('/products/')[1]?.split('/')[0] || ''; }
  function findVariant(cart, variantId) {
    var id=String(variantId||'');
    return (cart && Array.isArray(cart.items) ? cart.items : []).find(function(item){ return String(item.variant_id || item.id || '') === id && item.properties?.['_DaLuca strap add-on'] === 'true' && item.properties?.['_DaLuca add-on for'] === addonOwner(); }) || null;
  }
  async function addVariant(variantId, title) {
    return readJson(await fetch(url('cart/add.js'),{
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin',
      body:JSON.stringify({items:[{id:Number(variantId),quantity:1,properties:{'_DaLuca care item':'true'}}]})
    }),'Unable to add this option.');
  }
  async function removeVariant(item) {
    if (!item) return null;
    return readJson(await fetch(url('cart/change.js'),{
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin',
      body:JSON.stringify({id:item.key || item.id,quantity:Math.max(0,Number(item.quantity||1)-1)})
    }),'Unable to remove this option.');
  }
  function updateCount(cart) {
    if (!cart) return;
    document.querySelectorAll('.thb-item-count').forEach(function(n){ window.DaLucaI18n.setText(n, Number(cart.item_count)>99 ? '*' : String(cart.item_count||0)); });
  }
  function refreshCart(cart) {
    updateCount(cart);
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  }

  function buildCustomAddonCard(key, data) {
    var card=document.createElement('article');
    card.className='daluca-care-proxy-v35 daluca-strap-addon-card-v360';
    card.dataset.dalucaStrapAddonCard=key;
    card.dataset.variantId=data.variantId;
    if (data.image) {
      var media=document.createElement('div'); media.className='daluca-strap-addon-card-v360__media';
      var img=document.createElement('img'); img.src=data.image; img.alt=''; img.loading='lazy'; media.appendChild(img); card.appendChild(media);
    }
    var content=document.createElement('div'); content.className='daluca-care-proxy-v35__content';
    var strong=document.createElement('strong'); window.DaLucaI18n.setText(strong, data.title); content.appendChild(strong);
    var small=document.createElement('small'); window.DaLucaI18n.setText(small, data.reason); content.appendChild(small);
    var price=document.createElement('span'); window.DaLucaI18n.setText(price, data.price); content.appendChild(price);
    card.appendChild(content);
    var button=document.createElement('button'); button.type='button'; button.className='daluca-care-proxy-v35__add daluca-strap-addon-card-v360__button'; window.DaLucaI18n.setText(button, 'Add +');
    card.appendChild(button);
    return card;
  }

  async function syncCustomCards(r) {
    var cards=Array.from(document.querySelectorAll('[data-daluca-strap-addon-card]')).filter(function(card){ return !card.hasAttribute('data-daluca-care-proxy'); });
    if (!cards.length) return;
    try {
      var cart=await getCart();
      cards.forEach(function(card){
        var item=findVariant(cart,card.dataset.variantId);
        card.classList.toggle('is-selected',!!item);
        var b=card.querySelector('button'); if (b) { window.DaLucaI18n.setText(b, item?'Remove −':'Add +'); b.dataset.inCart=item?'1':'0'; }
      });
      updateCount(cart);
    } catch (_) {}
  }

  function mountCustomCards(r) {
    if (!r || !r.classList.contains('daluca-pdp--custom')) return;
    var items=document.querySelector('.daluca-custom-builder-live--consolidated .daluca-care-inline-v35__items');
    if (!items) return;
    if (document.querySelector('.daluca-custom-builder-live--consolidated')) {
      items.querySelectorAll('[data-daluca-strap-addon-card]:not([data-daluca-care-proxy])').forEach(function(card){card.remove();});
      return;
    }
    var title=window.DaLucaI18n.chainText(() => (document.querySelector('.daluca-concierge-header h1') || document.querySelector('h1')), [{kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || 'DaLuca strap';
    var configs=[];
    if (r.dataset.dalucaSpringBarsVariantId) configs.push({key:'spring-bars',variantId:r.dataset.dalucaSpringBarsVariantId,title:'Extra Spring Bars',reason:'Extra standard pair for future strap changes.',price:r.dataset.dalucaSpringBarsPrice || '',image:r.dataset.dalucaSpringBarsImage || ''});
    if (r.dataset.dalucaQuickReleaseEligible === 'true' && r.dataset.dalucaQuickReleaseVariantId) configs.push({key:'quick-release',variantId:r.dataset.dalucaQuickReleaseVariantId,title:'Quick-Release Spring Bars',reason:'Change compatible straps without a tool.',price:r.dataset.dalucaQuickReleasePrice || '',image:r.dataset.dalucaQuickReleaseImage || ''});
    configs.forEach(function(cfg){
      if (items.querySelector('[data-daluca-strap-addon-card="'+cfg.key+'"]')) return;
      var card=buildCustomAddonCard(cfg.key,cfg);
      var btn=card.querySelector('button');
      btn.addEventListener('click',async function(e){
        e.preventDefault(); e.stopPropagation();
        btn.disabled=true; btn.classList.add('is-busy');
        try {
          var cart=await getCart(); var existing=findVariant(cart,cfg.variantId);
          window.DaLucaI18n.setText(btn, existing?'Removing…':'Adding…');
          if (existing) await removeVariant(existing); else await addVariant(cfg.variantId,title);
          var updated=await getCart(); var now=findVariant(updated,cfg.variantId);
          card.classList.toggle('is-selected',!!now); window.DaLucaI18n.setText(btn, now?'Remove −':'Add +'); btn.dataset.inCart=now?'1':'0'; refreshCart(updated);
        } catch (err) {
          window.DaLucaI18n.setText(btn, 'Try again'); btn.title=err && err.message ? err.message : 'Unable to update cart';
        } finally { btn.disabled=false; btn.classList.remove('is-busy'); }
      });
      items.appendChild(card);
    });
    syncCustomCards(r);
  }

  function nonCustomUpgradeSection(r) { return r && r.querySelector('[data-daluca-strap-upgrades]'); }
  function selectedUpgradeInputs(section) { return section ? Array.from(section.querySelectorAll('[data-daluca-strap-upgrade-toggle]:checked')) : []; }
  // Quick-release modifies each strap; independent care products remain one per selection.
  function selectedUpgradeQuantity(input, strapQuantity) {
    return input.dataset.addonKey === 'quick-release' ? strapQuantity : 1;
  }
  function readyStrapSelection(r) {
    if (r.classList.contains('daluca-pdp--custom') || r.classList.contains('daluca-pdp--ooak')) return '';
    var values = [], seen = {};
    var selectors = Array.from(r.querySelectorAll('variant-selects:not(.variant-selects--sticky)'));
    var picker = selectors.find(function(el){return el.dataset.updateUrl === 'true';}) || selectors[0];
    var add = function(name,value){
      var key = /colou?r/i.test(name) ? 'color' : (/width/i.test(name) || (/^size$/i.test(name) && /^\d+(?:\.\d+)?\s*mm$/i.test(String(value||'').trim()))) ? 'width' : '';
      value = String(value||'').replace(/\s*\([^)]*\)/g,'').trim();
      if(key && value && !/please select|not selected/i.test(value) && !seen[key]) {seen[key]=true;values.push(key === 'color' ? window.DaLucaI18n.displayText(value) : value);}
    };
    if(picker) picker.querySelectorAll('fieldset').forEach(function(field){
      var input=field.querySelector('input:checked,select');
      if(input) add(field.dataset.handle||'',input.value);
    });
    r.querySelectorAll('.gpo-element').forEach(function(field){
      var name=window.DaLucaI18n.chainText(() => (field), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.gpo-label .label-content']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}])||'';
      if(!/^(?:(?:leather|strap|nylon|shell cordovan|lug)\s+)?(?:colou?r|width)$/i.test(name))return;
      var input=field.querySelector('input:checked,select');
      if(input && !field.hidden && getComputedStyle(field).display!=='none')add(name,input.value);
    });
    return values.join(' · ');
  }
  function updateNonCustomTotal(r,section) {
    if (!r || !section) return;
    var base=Number(r.dataset.dalucaBasePriceCents||0);
    var quantityInput=r.querySelector('product-form:not([data-sticky]) [name="quantity"],.daluca-concierge-step--complete [name="quantity"]');
    var quantity=Math.max(1,Number(quantityInput&&quantityInput.value)||1);
    var extra=selectedUpgradeInputs(section).reduce(function(sum,input){ return sum + (Number(input.dataset.priceCents)||0) * selectedUpgradeQuantity(input,quantity); },0);
    var total=r.querySelector('[data-daluca-total-base]');
    if (total) window.DaLucaI18n.setText(total, money(base*quantity+extra,r.dataset.dalucaCurrencyCode||'USD'));
    var legacy=r.querySelector('[data-daluca-total-upgraded]'); if (legacy) legacy.hidden=true;
    var complete=r.querySelector('.daluca-concierge-step--complete');
    if(complete){
      var price=complete.querySelector('.daluca-concierge-total');
      var summary=complete.querySelector('[data-daluca-ready-selected-addons]');
      if(!summary){summary=document.createElement('div');summary.dataset.dalucaReadySelectedAddons='true';summary.className='daluca-ready-selected-addons';summary.setAttribute('aria-live','polite');}
      if(price) price.before(summary); else complete.appendChild(summary);
      summary.replaceChildren();summary.hidden=false;
      var line=function(label,amount,cls){var row=document.createElement('div');row.className='daluca-ready-price-line'+(cls?' '+cls:'');var name=document.createElement('span');window.DaLucaI18n.setText(name, label);var value=document.createElement('strong');window.DaLucaI18n.setText(value, amount);row.append(name,value);summary.appendChild(row);};
      var currency=r.dataset.dalucaCurrencyCode||'USD';
      var selection=readyStrapSelection(r);
      line(r.dataset.dalucaLabelStrapPrice+(selection?' · '+selection:'')+(quantity>1?' × '+quantity:''),money(base*quantity,currency));
      selectedUpgradeInputs(section).forEach(function(input){var card=input.closest('.daluca-master-addon-card-v366,label');var name=card&&card.querySelector('.daluca-master-addon-card-v366__copy strong,strong');var units=selectedUpgradeQuantity(input,quantity);line((name?window.DaLucaI18n.sourceText(name).trim():input.dataset.addonKey)+(units>1?' × '+units:''),'+'+money(Number(input.dataset.priceCents)*units,currency),'daluca-price-fee');});
      line(r.dataset.dalucaLabelAddonsTotal,(extra>0?'+':'')+money(extra,currency),'daluca-price-extras-total');
      if(price){price.classList.add('daluca-itemized-order-total');var label=price.querySelector('span');if(label){window.DaLucaI18n.setText(label, r.dataset.dalucaLabelEstimatedTotal);label.classList.add('daluca-price-total-label');}}
    }
  }

  function formProperties(form) {
    var props={};
    new FormData(form).forEach(function(v,k){ var m=String(k).match(/^properties\[(.+)\]$/); if(m&&String(v).trim()) props[m[1]]=v; });
    return props;
  }
  function initNonCustom(r) {
    if (!r || r.classList.contains('daluca-pdp--custom')) return;
    var section=nonCustomUpgradeSection(r); if (!section || section.dataset.dalucaV360Ready==='1') return;
    section.dataset.dalucaV360Ready='1';
    ['input','change'].forEach(function(eventName){r.addEventListener(eventName,function(e){if(e.target.matches('[name="quantity"]')||e.target.closest('variant-selects,.gpo-element'))updateNonCustomTotal(r,section);});});
    ['variant:change','product:variant-change'].forEach(function(name){r.addEventListener(name,function(){updateNonCustomTotal(r,section);});});
    new MutationObserver(function(){updateNonCustomTotal(r,section);}).observe(r,{attributes:true,attributeFilter:['data-daluca-base-price-cents']});
    section.addEventListener('change',function(e){ if(e.target.matches('[data-daluca-strap-upgrade-toggle]')) updateNonCustomTotal(r,section); });
    updateNonCustomTotal(r,section);
    var pf=r.querySelector('product-form:not([data-sticky])'); var form=pf && pf.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    form.addEventListener('submit',async function(e){
      var chosen=selectedUpgradeInputs(section).filter(function(input){return !input.disabled;}); if(!chosen.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      var submit=Array.from(document.querySelectorAll('.single-add-to-cart-button')); submit.forEach(function(b){b.disabled=true;b.classList.add('loading');});
      try {
        var fd=new FormData(form); var id=Number(fd.get('id')); var qty=Math.max(1,Number(fd.get('quantity'))||1); var props=formProperties(form);
        // Care products are independent; quick-release is one modification per strap.
        // Keep the parent properties identical to a strap added without extras.
        var items=[{id:id,quantity:qty,properties:props}]; if(fd.get('selling_plan')) items[0].selling_plan=Number(fd.get('selling_plan'));
        chosen.forEach(function(input){
          var addonProps={'_DaLuca care item':'true'};
          if(input.dataset.addonKey==='quick-release'){
            addonProps={'For strap':window.DaLucaI18n.chainText(() => (document.querySelector('.daluca-concierge-header h1')||document.querySelector('h1')), [{kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}])||'DaLuca strap'};
            addonProps['_DaLuca linked upgrade']='true';
            addonProps['_DaLuca parent variant']=String(id);
            addonProps['_DaLuca parent options']=JSON.stringify(Object.keys(props).sort().reduce(function(out,name){out[name]=String(props[name]);return out;},{}));
          }
          items.push({id:Number(input.dataset.variantId),quantity:selectedUpgradeQuantity(input,qty),properties:addonProps});
        });
        var response=await fetch(url('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin',body:JSON.stringify({items:items,sections:pf.getSectionsToRender().map(function(section){return section.section;}),sections_url:location.pathname})});
        var data=await readJson(response,'Unable to add strap and options.');
        chosen.forEach(function(input){
          input.checked=false;
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
        updateNonCustomTotal(r,section);
        if(data.sections) pf.renderContents(data);
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:item-added',{bubbles:true,detail:{product:data.items&&data.items[0]?data.items[0]:data}}));
        try { var cart=await getCart(); updateCount(cart); } catch (_) {}
      } catch(err) {
        // Shopify can accept available quantities before returning an inventory warning.
        try { var actualCart=await getCart();updateCount(actualCart);document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); } catch (_) {}
        var wrap=pf.querySelector('.product-form__error-message-wrapper'); var msg=wrap&&wrap.querySelector('.product-form__error-message'); if(wrap) wrap.hidden=false; if(msg) window.DaLucaI18n.setText(msg, err&&err.message?err.message:'Unable to add strap and options.');
      } finally { submit.forEach(function(b){b.disabled=false;b.classList.remove('loading');}); }
    },true);
  }

  function run() { var r=root(); if(!r) return; mountCustomCards(r); initNonCustom(r); }
  var t=0; function queue(){clearTimeout(t);t=setTimeout(run,80);} 
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
  if(document.body) new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',queue);
  document.addEventListener('daluca:cart-edit-services',function(){var r=root();if(r)updateNonCustomTotal(r,nonCustomUpgradeSection(r));});
  [150,450,900,1800,3200].forEach(function(d){setTimeout(run,d);});
})();






